import { render, staticRenderFns } from "./FieldCheckbox.vue?vue&type=template&id=fedfa8e4&scoped=true"
import script from "./FieldCheckbox.vue?vue&type=script&lang=ts"
export * from "./FieldCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./FieldCheckbox.vue?vue&type=style&index=0&id=fedfa8e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedfa8e4",
  null
  
)

export default component.exports